/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        tooltip: 'Dashboard',
        type: 'basic',
        icon: 'mat_outline:space_dashboard',
        link: '/dashboard',
        // children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'application',
        title: 'Application',
        tooltip: 'Application',
        type: 'basic',
        icon: 'mat_outline:app_registration',
        link: '/application',
    },
    {
        id: 'location',
        title: 'Location',
        tooltip: 'Location',
        type: 'collapsable',
        icon: 'heroicons_outline:map-pin',
        children: [
            // Hidden 20-Oct-2026 with its route (see app.routes.ts)
            // {
            //     id: 'country',
            //     title: 'Country',
            //     tooltip: 'Country',
            //     type: 'basic',
            //     icon: 'heroicons_outline:globe-americas',
            //     link: '/country',
            // },
            {
                id: 'postcode',
                title: 'Postcode',
                tooltip: 'PostCode',
                type: 'basic',
                icon: 'mat_outline:share_location',
                link: '/postcode',
            },
            {
                id: 'regions',
                title: 'Region',
                tooltip: 'Region',
                type: 'basic',
                icon: 'mat_outline:location_searching',
                link: '/region',
            },
        ],
    },
    {
        id: 'users',
        title: 'Users',
        tooltip: 'Users',
        type: 'collapsable',
        icon: 'heroicons_outline:users',
        children: [
            // Hidden 21-Oct-2026: the Users menu keeps only Internal User and Customers ("User" listed both together)
            // {
            //     id: 'user',
            //     title: 'User',
            //     tooltip: 'User',
            //     type: 'basic',
            //     icon: 'heroicons_outline:user-plus',
            //     link: '/user',
            // },
            {
                id: 'internal-user',
                title: 'Internal User',
                tooltip: 'Internal User',
                type: 'basic',
                icon: 'heroicons_outline:user-plus',
                link: '/user',
                queryParams : {filter:'internal'}
            },
            // moved here from the top level (21-Oct-2026)
            {
                id: 'customers',
                title: 'Customers',
                tooltip: 'Customers',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/user',
                queryParams: { filter: 'customer' },
            },
            // Hidden 20-Oct-2026 with its route (see app.routes.ts)
            // {
            //     id: 'role',
            //     title: 'Role',
            //     tooltip: 'Role',
            //     type: 'basic',
            //     icon: 'mat_outline:share_location',
            //     link: '/role',
            // }
        ],
    },
    // Moved into the Users menu (21-Oct-2026)
    // {
    //     id: 'customers',
    //     title: 'Customers',
    //     tooltip: 'Customers',
    //     type: 'basic',
    //     icon: 'heroicons_outline:user-group',
    //     link: '/user',
    //     queryParams: { filter: 'customer' },
    // },
    {
        id: 'scope',
        title: 'Scope',
        tooltip: 'Scopes',
        type: 'basic',
        icon: 'mat_outline:donut_large',
        link: '/scope',
    },
    {
        id: 'pelob',
        title: 'Line of Business (LOB)',
        tooltip: 'Line of Business',
        type: 'basic',
        icon: 'mat_outline:blur_circular',
        link: '/pe-lob',
    },
    {
        id: 'meter-points',
        title: 'Meter Points',
        tooltip: 'Meter Points (MPAN / MPRN / SPID)',
        type: 'basic',
        // 'electric_meter' is not in assets/icons/material-outline.svg, so the menu showed an empty circle
        // icon: 'mat_outline:electric_meter',
        icon: 'mat_outline:speed',
        link: '/meter-points',
    },
];

// Hidden 20-Oct-2026: these menu sets are never shown (the layout uses defaultNavigation only) and every link in
// them pointed to a page that does not exist (Calculator, Business Travels, Alert Message, Hotel Stay, Example).
export const compactNavigation: FuseNavigationItem[] = [
    // {
    //     id: 'dashboards',
    //     title: 'Dashboards',
    //     tooltip: 'Dashboard',
    //     type: 'basic',
    //     icon: 'mat_outline:space_dashboard',
    //     link: '/dashboards/project',
    //     // children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    // },
    // {
    //     id: 'calculator',
    //     title: 'Calculator',
    //     tooltip: 'Calculator',
    //     type: 'collapsable',
    //     icon: 'heroicons_outline:calculator',
    //     children: [
    //         {
    //             id: 'newCalculation',
    //             title: 'New Calculation',
    //             tooltip: 'New Calculation',
    //             type: 'basic',
    //             icon: 'heroicons_outline:calculator',
    //             link: '/calculator/welcome',
    //         },
    //         {
    //             id: 'listOfCalculations',
    //             title: 'List Of Calculations',
    //             tooltip: 'List Of Calculations',
    //             type: 'basic',
    //             icon: 'heroicons_outline:calculator',
    //             link: '/calculator/list',
    //         },
    //     ],
    // },
    // {
    //     id: 'businessTravels',
    //     title: 'Business Travels',
    //     tooltip: 'Business Travels',
    //     type: 'collapsable',
    //     icon: 'mat_outline:travel_explore',
    //     children: [
    //         {
    //             id: 'byLand',
    //             title: 'By Land',
    //             tooltip: 'By Land',
    //             type: 'basic',
    //             icon: 'mat_outline:add_road',
    //             link: '/business-travel/land',
    //         },
    //         {
    //             id: 'bySea',
    //             title: 'By Sea',
    //             type: 'basic',
    //             tooltip: 'By Sea',
    //             icon: 'mat_outline:water',
    //             link: '/business-travel/sea',
    //         },
    //         {
    //             id: 'byAir',
    //             title: 'By Air',
    //             type: 'basic',
    //             tooltip: 'By Air',
    //             icon: 'mat_outline:local_airport',
    //             link: '/business-travel/air',
    //         },
    //     ],
    // },
    // {
    //     id: 'alertMessage',
    //     title: 'Alert Message',
    //     tooltip: 'Alert Message',
    //     type: 'basic',
    //     icon: 'heroicons_outline:bell',
    //     link: '/alert-message',
    // },
    // {
    //     id: 'hotelStay',
    //     title: 'Hotel Stay',
    //     tooltip: 'Hotel Stay',
    //     type: 'basic',
    //     icon: 'mat_outline:hotel',
    //     link: '/hotelstay',
    // },
];
export const futuristicNavigation: FuseNavigationItem[] = [
    // {
    //     id: 'example',
    //     title: 'Example',
    //     type: 'basic',
    //     icon: 'heroicons_outline:chart-pie',
    //     link: '/example',
    // },
];
export const horizontalNavigation: FuseNavigationItem[] = [
    // {
    //     id: 'example',
    //     title: 'Example',
    //     type: 'basic',
    //     icon: 'heroicons_outline:chart-pie',
    //     link: '/example',
    // },
];
